<template>
  <div id="contents">
    <div id="exModify" class="container">
      <h3 class="stitle mb10">예약변경</h3>
      <ul class="colorBox tleft mb50 tlist">
        <li>상품 및 체험일을 변경하시려면 예약취소 후 다시 예약을 해야 합니다.</li>
        <li>예약변경 후 예약확인 &gt; 예약확인/변경/취소 메뉴에서 체험실 선택을 확인하여 주시기 바랍니다.</li>
      </ul>
      <h4 class="stitle2 mb10 tleft">체험관 예약변경</h4>
      <div class="tb_wrap mb30 res_tbl_grid_wrap">
        <table class="tb_basic">
          <caption>예약정보</caption>
          <tbody>
            <tr>
              <th class="tbg cw120">예약번호</th>
              <td class="tleft">{{ bundleRvNo }}</td>
              <th class="tbg cw120">예약상태</th>
              <td class="tleft">{{ reserveInfo.rvSitu }}</td>
            </tr>
            <tr>
              <th class="tbg cw120">예약일</th>
              <td class="tleft">{{ reserveInfo.rvDtm }}</td>
              <th class="tbg cw120">예약자명</th>
              <td class="tleft">{{ reserveInfo.userName }}</td>
            </tr>
            <tr>
              <th class="tbg cw120">휴대폰</th>
              <td class="tleft">{{ reserveInfo.userMobileNum }}</td>
              <th class="tbg cw120">이메일</th>
              <td class="tleft">{{ reserveInfo.userEmail }}</td>
            </tr>
            <tr v-if="reserveInfo.hpOrgInfoId > 0">
              <th class="tbg cw120">단체명</th>
              <td class="tleft">{{ reserveInfo.orgName }}</td>
              <th class="tbg cw120">학년</th>
              <td class="tleft">{{ reserveInfo.gradeNm }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="tb_wrap mb10">
        <table class="tb_basic">
          <caption>상품 예약 목록</caption>
          <colgroup>
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col width="100" />
          </colgroup>
          <thead>
            <tr class="tbg">
              <th scope="col">체험일</th>
              <th scope="col">상품</th>
              <th scope="col">회차</th>
              <th scope="col">인원</th>
              <th scope="col">금액</th>
              <th scope="col">할인금액</th>
              <th scope="col">변경</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rv, i) in changedDetialList" :key="rv.pdRvNo">
              <td v-if="i === 0" :rowspan="changedDetialList.length">{{ rv.expVisitRvdtF }}</td>
              <td>
                {{ rv.pdNm }}
              </td>
              <template v-if="rv.changed && rv.changed.scheSeqNo">
                <td :class="{ changed: rv.scheSeqNo !== rv.changed.scheSeqNo }">{{ rv.changed.scheSeqNo }}회차{{ rv.changed.scheTm }}</td>
                <td class="tleft">
                  <ul class="tlist1">
                    <li :class="{ changed: rv.experPcnt !== rv.changed.experPcnt }">
                      <strong>체험자</strong>
                      <span>{{ rv.changed.experPcnt }}인</span>
                    </li>
                    <li :class="{ changed: rv.leaderPcnt !== rv.changed.leaderPcnt }" v-if="rv.leaderPcnt > 0">
                      <strong>보호자</strong>
                      <span>{{ rv.changed.leaderPcnt }}인</span>
                    </li>
                  </ul>
                </td>
              </template>
              <template v-else>
                <td>{{ rv.scheSeqNo }}회차({{ rv.scheTm }})</td>
                <td class="tleft">
                  <ul class="tlist1">
                    <li>
                      <strong>체험자</strong>
                      <span>{{ rv.experPcnt }}인</span>
                    </li>
                    <li v-if="rv.leaderPcnt > 0">
                      <strong>보호자</strong>
                      <span>{{ rv.leaderPcnt }}인</span>
                    </li>
                  </ul>
                </td>
              </template>
              <template v-if="rv.changed">
                <td :class="{ changed: rv.rvAmt + rv.dcAmt !== rv.changed.rvAmt + rv.changed.dcAmt }" class="tright">
                  {{ _wonFormat(rv.changed.rvAmt + rv.changed.dcAmt) }}
                </td>
                <td :class="{ changed: rv.dcAmt !== rv.changed.dcAmt }" class="tright">{{ _wonFormat(rv.changed.dcAmt) }}</td>
              </template>
              <template v-else>
                <td class="tright">{{ _wonFormat(rv.rvAmt + rv.dcAmt) }}</td>
                <td class="tright">{{ _wonFormat(rv.dcAmt) }}</td>
              </template>
              <td>
                <span v-if="rv.rvCancelYn == 'Y'">
                  취소
                  <br />
                  ({{ rv.rvCancelDtm }})
                </span>
                <ReseveChangePopup v-else :pdRvNo="rv.pdRvNo" :mrktnPdYn="rv.mrktnPdYn" :couponsaleSeq="rv.couponsaleSeq" :confirmChange="setChangeDetailList">
                  <span class="ticket_btnbox"><a class="btn_detail">변경</a></span>
                </ReseveChangePopup>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ul class="tleft colorBox mb50">
        <li>*팝업화면에서 예약 변경 후 변경화면 하단 예약변경 적용(저장)버튼까지 클릭하셔야 최종 변경됩니다.</li>
        <li>*회차를 변경하거나 체험자 인원을 줄일 경우 기존에 선택된 체험실이 삭제됩니다.</li>
      </ul>
      <h4 class="stitle2 mb10 tleft">변경결제내역</h4>
      <div class="totalPriceBox mb50">
        <ul class="div4">
          <template v-if="diffAmt >= 0">
            <li>
              <strong>변경 체험금액</strong>
              <span>
                <i class="fs_big tcolor1">{{ _priceFormat(totSaleAmt) }}</i>
                원
              </span>
            </li>
            <li class="price_icon1">
              <strong>변경전 체험금액</strong>
              <span>
                <i class="fs_big">{{ _priceFormat(preChangeSaleAmt) }}</i>
                원
              </span>
            </li>
          </template>
          <template v-else>
            <li>
              <strong>변경전 체험금액</strong>
              <span>
                <i class="fs_big">{{ _priceFormat(preChangeSaleAmt) }}</i>
                원
              </span>
            </li>
            <li class="price_icon1">
              <strong>변경 체험금액</strong>
              <span>
                <i class="fs_big tcolor1">{{ _priceFormat(totSaleAmt) }}</i>
                원
              </span>
            </li>
          </template>
          <li class="price_icon3">
            <strong>{{ diffText }}</strong>
            <span>
              <i class="fs_big">{{ _priceFormat(diffAmtTxt) }}</i>
              원
            </span>
          </li>
        </ul>
      </div>

      <!--환불계좌 - 무통장입금인 경우 -->
      <div v-if="payInfo.payMethod == '04' && diffAmt < 0">
        <h4 class="stitle2 mb10 tleft">환불계좌</h4>
        <div class="tb_wrap mb20">
          <table class="tb_basic">
            <caption></caption>
            <tbody>
              <tr>
                <th class="tbg">환불은행</th>
                <td class="tleft">
                  <select style="width: 160px" v-model="nobankRefuBankCd">
                    <option selected value="">은행선택</option>
                    <option v-for="item in refundBankList" :key="item.cd" :value="item.cd">{{ item.cdNm }}</option>
                  </select>
                </td>
                <th class="tbg">환불계좌번호</th>
                <td class="tleft">
                  <input type="text" style="width: 180px" v-model="nobankRefuAccNo" number maxlength="20" />
                </td>
                <th class="tbg">환불계좌주명</th>
                <td class="tleft">
                  <input type="text" style="width: 180px" v-model="nobankRefuAccNm" maxlength="100" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!--//환불계좌-->

      <div class="agree_wrap mb10">
        <div class="agree_cont">
          <ReserveInfoText />
        </div>
      </div>
      <p class="linebox checkbox mb50">
        <input type="checkbox" name="agree" id="agree01" v-model="confirmCheck" />
        <label for="agree01">
          예약안내 및 유의사항 동의
          <strong class="tcolor2">(필수)</strong>
        </label>
      </p>
      <div class="btn_area">
        <router-link class="btn btn_bg gray" :to="`/${currentRouteType}/reservations`">예약목록</router-link>
        <a class="btn btn_bg color2" @click="onChangeClick">예약변경적용(저장)</a>
      </div>
    </div>
  </div>
</template>

<script>
import { getReservation, calcModifyPrice, modifyReserve } from '@/api/api_reserve';
import ReseveChangePopup from '@/components/popup/ReseveChangePopup';
import ReserveInfoText from '@/components/popup/ReserveInfoText';

export default {
  components: { ReseveChangePopup, ReserveInfoText },
  data() {
    return {
      message: '',
      bundleRvNo: '',
      targetPdRvNo: '',
      reserveInfo: {},
      detailList: [],
      payInfo: {},
      refundBankList: [],
      changedList: [],
      preChangeSaleAmt: 0,
      totSaleAmt: 0,
      diffAmt: 0,
      nobankRefuBankCd: '',
      nobankRefuAccNo: '',
      nobankRefuAccNm: '',
      confirmCheck: false,
      reservePgRoute: '',
    };
  },
  computed: {
    changedDetialList() {
      return this.detailList.map((d) => {
        d.pdRvNo;
        return {
          ...d,
          changed: this.changedList.find((e) => e.pdRvNo === d.pdRvNo),
        };
      });
    },
    diffText() {
      return this.diffAmt >= 0 ? '추가금액' : '환불금액';
    },
    diffAmtTxt() {
      return Math.abs(this.diffAmt);
    },
    totOriginPrice() {
      return this.detailList.reduce((a, e) => a + e.rvAmt + e.dcAmt, 0);
    },
    totDcPrice() {
      return this.detailList.reduce((a, e) => a + e.dcAmt, 0);
    },
    totSalePrice() {
      return this.detailList.reduce((a, e) => a + e.rvAmt, 0);
    },
  },
  methods: {
    async setChangeDetailList(changeRv) {
      try {
        const idx = this.changedList.findIndex((e) => e.pdRvNo === changeRv.pdRvNo);
        const clear = changeRv.clear || false;

        if (clear && idx > -1) {
          this.changedList.splice(idx, 1);
        } else {
          if (idx > -1) {
            this.changedList.splice(idx, 1, changeRv);
          } else {
            this.changedList.push(changeRv);
          }
        }

        const result = await calcModifyPrice({ bundleRvNo: this.bundleRvNo, bookingList: this.changedList.filter((e) => e.scheSeqNo) });

        if (result.success) {
          const modifyPrice = result.response;
          const priceList = modifyPrice.priceList;
          this.preChangeSaleAmt = modifyPrice.preChangeSaleAmt;
          this.totSaleAmt = modifyPrice.totSaleAmt;
          this.diffAmt = modifyPrice.diffAmt;

          priceList.forEach((e) => {
            const changed = this.changedList.find((d) => d.pdRvNo === e.pdRvNo);
            if (changed) {
              changed.rvAmt = e.saleAmt;
              changed.dcAmt = e.dcPrice;
            } else {
              this.changedList.push({ pdRvNo: e.pdRvNo, rvAmt: e.saleAmt, dcAmt: e.dcPrice });
            }
          });
        } else {
          throw result.message;
        }
      } catch (e) {
        alert('오류가 발생 하였습니다. 변경할 수 없습니다.');
      }
    },
    async refundAndModifyReserve(reqOrder) {
      try {
        const result = await modifyReserve(reqOrder);
        if (result.success) {
          alert('예약 변경이 완료 되었습니다.');
          this.$router.push('/' + this.reservePgRoute + '/reservations/' + this.bundleRvNo);
        }
      } catch (e) {
        alert('오류가 발생 하였습니다.');
        console.log(e);
      }
    },
    async onChangeClick() {
      const changedList = this.changedList.filter((e) => e.scheSeqNo);
      let bankParam = {};

      if (changedList.length < 1) {
        alert('변경된 예약 내역이 없습니다.');
        return false;
      }

      //예약 완료 상태일때만 추가 결제를한다.
      if (this.reserveInfo.rvProgSitu === '03' && this.diffAmt > 0) {
        //현 로직상 추가 결제가 필요한 경우는 없다. 추가 요청 사항 있을시 구현
        return false;
      } else if (this.diffAmt < 0) {
        if (this.payInfo.payMethod === '04') {
          if (!this.nobankRefuBankCd) {
            alert('환불은행을 선택해 주세요.');
            return false;
          }

          if (!this.nobankRefuAccNo) {
            alert('환불계좌번호를 입력해 주세요.');
            return false;
          }

          if (!this.nobankRefuAccNm) {
            alert('환불계좌주명을 입력해 주세요.');
            return false;
          }

          bankParam = {
            payMethod: '04',
            nobankRefuBankCd: this.nobankRefuBankCd,
            nobankRefuAccNo: this.nobankRefuAccNo,
            nobankRefuAccNm: this.nobankRefuAccNm,
          };
        }
      }

      if (!this.confirmCheck) {
        alert('예약안내 및 유의사항 동의를 해주세요');
        return false;
      }

      customConfirm('예약을 변경하시겠습니까?', (confirm) => {
        if (confirm) {
          this.refundAndModifyReserve({ bundleRvNo: this.bundleRvNo, bookingList: changedList, ...bankParam });
        }
      });
    },
  },
  created() {
    this.bundleRvNo = this.$route.params.bundleRvNo;
    getReservation(this.bundleRvNo).then((data) => {
      if (data.success) {
        const { reserveInfo, detailList, payInfo, refundBankList } = data.response;

        if (reserveInfo.payMethod == '09') {
          alert('체험카드 예약분은 예약변경이 불가능 합니다.');
          this.$router.go(-1);
        }

        this.reserveInfo = reserveInfo;
        this.detailList = detailList;
        this.payInfo = payInfo || {};
        this.refundBankList = refundBankList;
        this.reservePgRoute = reserveInfo.groupPersDiv === '01' ? 'grp' : 'ind';
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.changed {
  color: #bd0000;
}
.tlist1 {
  & span {
    padding-left: 5px;
  }
}
</style>
